module.exports = __webpack_public_path__ + "static/media/Teuko kids lunchbox ideas community landing features Search _compressed.5a4f7766.mp4";